import api from './api';

const accountLivenessService = {
  // Get service status and summary
  getStatus: async () => {
    const response = await api.get('/account-liveness/status');
    return response.data;
  },
  
  // Check specific account liveness
  checkAccount: async (accountId) => {
    const response = await api.post(`/account-liveness/accounts/${accountId}/check`);
    return response.data;
  },
  
  // Force check specific account (bypass cache/delays)
  forceCheckAccount: async (accountId) => {
    const response = await api.post(`/account-liveness/accounts/${accountId}/check`);
    return response.data;
  },

  // Force immediate check cycle for all accounts
  forceCheckNow: async () => {
    const response = await api.post('/account-liveness/force-check');
    return response.data;
  },
  
  // Start the account liveness service
  startService: async () => {
    const response = await api.post('/account-liveness/start');
    return response.data;
  },
  
  // Stop the account liveness service
  stopService: async () => {
    const response = await api.post('/account-liveness/stop');
    return response.data;
  },
  
  // Get service configuration
  getConfig: async () => {
    const response = await api.get('/account-liveness/config');
    return response.data;
  },
  
  // Update service configuration
  updateConfig: async (config) => {
    const response = await api.put('/account-liveness/config', config);
    return response.data;
  }
};

export default accountLivenessService;
